// src/polyfill.js
import bigInt from 'big-integer';

if (typeof BigInt === 'undefined') {
    window.BigInt = bigInt;
}
